import React from 'react';
import './HeroSection.css';
import heroImage from '../assets/hero-phone.png'; 
const HeroSection = () => {
  return (
    <section className="hero-section" id="top">
      <div className="container hero-content-wrapper">
        <div className="hero-text">
          <h1>Desarrollo de <br /> Software, <br /> Apps y Diseño <br /> de Marca</h1>
          <p>Fortalece tu presencia digital <br /> con seguridad y confianza</p>
        </div>
        <div className="hero-image-container">
          <img src={heroImage} alt="Phone showing digital services" className="hero-phone-img" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;